<template>
	<div id="schrittanzeige">

		<div class="row mb-5">
			<div class="col-12 col-lg-8 offset-lg-2">
				<div class="form-step-container">

					<div :class="{ 'form-step-box' : schritt !== 1, 'form-step-box form-box-active' : schritt === 1 }">1</div>
					<div :class="{ 'form-step-line' : schritt !== 1, 'form-step-line form-box-active' : schritt === 1 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 2, 'form-step-box form-box-active' : schritt === 2 }">2</div>
					<div :class="{ 'form-step-line' : schritt !== 2, 'form-step-line form-box-active' : schritt === 2 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 3, 'form-step-box form-box-active' : schritt === 3 }">3</div>
					<div :class="{ 'form-step-line' : schritt !== 3, 'form-step-line form-box-active' : schritt === 3 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 4, 'form-step-box form-box-active' : schritt === 4 }">4</div>
					<div :class="{ 'form-step-line' : schritt !== 4, 'form-step-line form-box-active' : schritt === 4 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 5, 'form-step-box form-box-active' : schritt === 5 }">5</div>
					<div :class="{ 'form-step-line' : schritt !== 5, 'form-step-line form-box-active' : schritt === 5 }"></div>

					<div :class="{ 'form-step-box' : schritt !== 6, 'form-step-box form-box-active' : schritt === 6 }">6</div>

				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-lg-8 offset-lg-2">
				<p class="form-info-text">
          Benötigen Sie Hilfe beim Ausfüllen des Formulars?<br /> Dann schreiben Sie bitte eine kurze E-Mail an <a href="mailto:info@rueden.de">info@rueden.de</a>
        </p>
			</div>
		</div>

	</div>
</template>
<script>
export default {

	name: "Schrittanzeige",
	props: ['schritt']

}
</script>
